import React from "react";
import Wrapper from "../layout/Wrapper";
import BannerComp from "../components/BannerComp/BannerComp";
import assests from "../ui/assests";
import WhoWeAreComp from "../components/WhoWeAreComp/WhoWeAreComp";
import MeetOurTeamComp from "../components/MeetOurTeamComp/MeetOurTeamComp";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";
import WhatweDoComp from "../components/WhatweDoComp/WhatweDoComp";

export default function About() {
  return (
    <Wrapper>
      <BannerComp
        className="about_banner"
        image={assests.innerbanner01}
        title="Crafting Digital Experiences That Drive Results"
        description="We are a web design and development company dedicated to delivering exceptional service to our clients."
      />
      <WhoWeAreComp />
      <WhatweDoComp />
      <MeetOurTeamComp />
      <DesignFutureSec />
    </Wrapper>
  );
}
